var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7236 2.55279C8.89299 2.214 9.23925 2 9.61803 2H14.382C14.7607 2 15.107 2.214 15.2764 2.55279L15.5 3H17.5604C18.9904 3 20.2217 4.00938 20.5021 5.41165L21.9806 12.8039L22 19C22 19.5523 21.5523 20 21 20V21C21 21.5523 20.5523 22 20 22H18C17.4477 22 17 21.5523 17 21V20H7V21C7 21.5523 6.55228 22 6 22H4C3.44772 22 3 21.5523 3 21V20C2.44772 20 2 19.5523 2 19L2.01942 12.8039L3.49787 5.41165C3.77832 4.00938 5.00956 3 6.43961 3H8.49999L8.7236 2.55279ZM6.43961 5C5.96293 5 5.55251 5.33646 5.45903 5.80389L4.2198 12H19.7802L18.541 5.80389C18.4475 5.33646 18.0371 5 17.5604 5H6.43961ZM5.5 17C6.32843 17 7 16.3284 7 15.5C7 14.6716 6.32843 14 5.5 14C4.67157 14 4 14.6716 4 15.5C4 16.3284 4.67157 17 5.5 17ZM20 15.5C20 14.6716 19.3284 14 18.5 14C17.6716 14 17 14.6716 17 15.5C17 16.3284 17.6716 17 18.5 17C19.3284 17 20 16.3284 20 15.5ZM10 15C9.44772 15 9 15.4477 9 16C9 16.5523 9.44772 17 10 17H14C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxi);
export default __webpack_public_path__ + "static/media/taxi.b6f4b6149517efd4b74c206be5959cfb.svg";
export { ForwardRef as ReactComponent };